import { selectPrimaryTipCandidate } from "./primaryTipSelection.js";
// One shared selection stage; callers supply existing model/market candidates.
export const TIP_MARKET_OPTIONS = [
  { id: "1x2", available: true },
  { id: "over-under", available: true },
  { id: "european-handicap", available: false },
  { id: "double-chance", available: true },
  { id: "btts", available: true },
  { id: "ht-ft", available: false },
  { id: "asian-goal-lines", available: true },
  { id: "asian-handicap", available: true },
  { id: "correct-score", available: true },
];
export function tipMarket(t) {
  if (t.market === "over-under")
    return Math.abs(Number(t.line) % 1) === 0.5
      ? "over-under"
      : "asian-goal-lines";
  return t.market;
}
export function selectTips(
  candidates,
  profile,
  {
    fair = (t) => t.fairOdd,
    quote = (t) => t.marketOdd,
    fixture = (t) => t.fixtureId,
    market = tipMarket,
  } = {}
) {
  const audit = { raw: candidates.length };
  let rows = candidates.filter(
    (t) =>
      Number.isFinite(fair(t)) &&
      fair(t) > 1 &&
      Number.isFinite(quote(t)) &&
      quote(t) > 1 &&
      Number.isFinite(t.value) &&
      !t.unavailable_reason
  );
  audit.valid = rows.length;
  rows = rows.filter((t) => t.value > 0 && t.value >= (profile.threshold ?? 0));
  audit.value = rows.length;
  rows = rows.filter(
    (t) =>
      (!profile.betTypes || profile.betTypes.length > 0) &&
      (!profile.markets || profile.markets.includes(market(t))) &&
      (profile.leagueIds == null ||
        profile.leagueIds.includes(Number(t.leagueId ?? t.league_id))) &&
      (profile.bookmakerIds == null ||
        profile.bookmakerIds.includes(
          Number(t.bookmaker?.id ?? t.bookmaker_id)
        )) &&
      quote(t) >= (profile.minOdd ?? 1.01) &&
      (profile.maxOdd == null || quote(t) <= profile.maxOdd)
  );
  audit.profile = rows.length;
  const groups = new Map();
  for (const t of rows) {
    const key = JSON.stringify([fixture(t), market(t)]);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push({
      original: t,
      distance: t.distance ?? 0,
      advantage: t.value,
      line: t.line,
      outcome: String(t.selection),
    });
  }
  const tips = [...groups.values()].map(
    (g) => selectPrimaryTipCandidate(g).original
  );
  audit.one_per_market = tips.length;
  audit.final = tips.length;
  return { tips, audit };
}

// Asian lines use the existing model's MBL. Classical half-goal totals remain separate.
export function onSelectedLine(t, ah, agl, awayLineIsCanonical = false) {
  if (t.market === "asian-handicap")
    return (
      ah != null &&
      Number(t.line) ===
        (t.selection === "away" && !awayLineIsCanonical
          ? -Number(ah)
          : Number(ah))
    );
  if (t.market === "over-under" && Math.abs(Number(t.line) % 1) !== 0.5)
    return agl != null && Number(t.line) === Number(agl);
  return true;
}
